///
/// @group Components
///
/// @param `--cwc-video-headline-padding-mobile` default: `1rem 1rem 0` sample: `1rem 2rem`
$video-headline-padding-mobile: var(--cwc-video-headline-padding-mobile, 1rem 1rem 0) !default;
/// @param `--cwc-video-headline-padding-desktop` default: `1rem 1.2rem` sample: `1rem 2rem`
$video-headline-padding-desktop: var(--cwc-video-headline-padding-desktop, 1rem 1.2rem) !default;
/// @param `--cwc-video-headline-background-color-desktop` default: `rgba(34, 34, 34, .46)` sample: `rgba(100, 100, 100, .5)`
$video-headline-background-color-desktop: var(
  --cwc-video-headline-background-color-desktop,
  rgba(34, 34, 34, 0.46)
) !default;
/// @param `--cwc-video-headline-text-color-desktop` default: `#fff` sample: `#f0f0f0`
$video-headline-text-color-desktop: var(--cwc-video-headline-text-color-desktop, #fff) !default;
/// @param `--cwc-video-headline-font-size` default: `2.5rem` sample: `1rem`
$video-headline-font-size: var(--cwc-video-headline-font-size, 2.5rem) !default;
/// @param `--cwc-video-headline-font-weight` default: `700` sample: `700`
$video-headline-font-weight: var(--cwc-video-headline-font-weight, 700) !default;
/// @param `--cwc-video-headline-line-height` default: `1.2` sample: `1.5`
$video-headline-line-height: var(--cwc-video-headline-line-height, 1.2) !default;

/// @param `--cwc-video-description-padding-mobile` default: `.5rem 1rem` sample: `2.5rem`
$video-description-padding-mobile: var(--cwc-video-description-padding-mobile, 0.5rem 1rem) !default;
/// @param `--cwc-video-description-padding-desktop` default: `1rem` sample: `2.5rem`
$video-description-padding-desktop: var(--cwc-video-description-padding-desktop, 1rem) !default;

:host {
  display: flex;
  flex-direction: column;
  width: 100%;

  cwc-video-head {
    display: flex;
    flex-direction: column;

    video {
      display: block;
      width: 100%;
    }

    cwc-video-headline {
      display: flex;
      justify-content: center;
      height: auto;
      margin: 0;
      padding: $video-headline-padding-mobile;
      font-size: $video-headline-font-size;
      font-weight: $video-headline-font-weight;
      line-height: $video-headline-line-height;
      text-align: center;
    }
  }

  cwc-video-description {
    display: flex;
    justify-content: center;
    padding: $video-description-padding-mobile;
    text-align: center;
  }
}

:host(.desktop) {
  cwc-video-head {
    position: relative;

    cwc-video-headline {
      position: absolute;
      right: 0;
      bottom: 0;
      left: 0;
      padding: $video-headline-padding-desktop;
      background-color: $video-headline-background-color-desktop;
      color: $video-headline-text-color-desktop;
    }
  }

  cwc-video-description {
    padding: $video-description-padding-desktop;
    text-align: center;
  }
}
